import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'
import media from '../../utils/media'
import Container from './Container'
import Image from './Image'
import Btn from './BtnLink'

const ContainerDiv = styled(Container)`
  width: 100%;
  max-width: ${props => props.cardWidth}px;
  padding: 15px;
  ${media.laptop`
    max-width: 400px;
  `}
  ${media.tablet`
    margin-bottom: ${props =>
      props.mobileMargins ? props.mobileMargins : '40px'};
  `}
  ${media.mobileL`
    padding-left: 0;
    padding-right: 0;
    max-width: 334px;
  `}
`

const Link = styled.a`
  p {
    text-decoration: none !important;
    color: #414141 !important;
    &:hover {
      color: #414141 !important;
    }
  }
`

const Eyebrow = styled.div`
  margin-bottom: 16px;
  p {
    font-family: ${props => props.titleFamily ?? 'Raleway'};
    font-size: ${props =>
      props.eyeBrowFSize ? props.eyeBrowFSize : '20'}px;
    /* font-size: 20px; */
    strong {
      font-weight: 800 !important;
    }
    line-height: ${props => props.lineHeight ?? 'normal'};
  }
`

const Title = styled.div`
  height: 150px;
  height: ${props => props.locale === 'de-de' && '160px'};
  height: ${props => props.locale === 'en-us' && '100px'};
  height: ${props => props.height};
  p {
    font-family: ${props =>
      props.titleFamily ? props.titleFamily : 'Raleway'};
    font-size: ${props =>
      props.titleFSize ? props.titleFSize : '25'}px;
    /* font-size: 25px; */
    line-height: 1.24;
  }
  ${media.mobileL`
    height: auto;
    margin-bottom: ${props =>
      props.mobileMargins ? props.mobileMargins : '30px'};
  `}
`

export default function Card({
  classN,
  imageClassName,
  src,
  alt,
  maxWidth,
  minWidth,
  marginB,
  eyeBrow,
  title,
  btnText,
  href,
  btnBg,
  btnColor,
  btnMarginT,
  btnMarginB,
  cardWidth,
  eyeBrowFSize,
  titleFSize,
  titleFamily,
  mobileMargins,
  noBtn,
  height,
  lineHeight,
}) {
  const [locale] = useStoreState(state => [state.locale.locale])
  const srcToShow = useTranslations(src, {})
  const hrefToShow = useTranslations(href, {})

  return (
    <ContainerDiv
      className={classN}
      cardWidth={cardWidth}
      mobileMargins={mobileMargins}
    >
      <Link href={hrefToShow}>
        <Image
          className={imageClassName}
          src={srcToShow}
          alt={alt}
          maxWidth={maxWidth}
          minWidth={minWidth}
          marginB={marginB}
        />
      </Link>
      <Link href={hrefToShow}>
        <Eyebrow
          titleFamily={titleFamily}
          eyeBrowFSize={eyeBrowFSize}
          lineHeight={lineHeight}
        >
          <Text id={eyeBrow} markdown />
        </Eyebrow>
      </Link>
      <Title
        locale={locale}
        height={height}
        titleFSize={titleFSize}
        titleFamily={titleFamily}
        mobileMargins={mobileMargins}
      >
        <Text id={title} markdown />
      </Title>
      {noBtn && (
        <Btn
          btnText={btnText}
          href={href}
          btnBg={btnBg}
          btnColor={btnColor}
          btnMarginT={btnMarginT}
          btnMarginB={btnMarginB}
        />
      )}
    </ContainerDiv>
  )
}
